import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export default function PageMotion({ children }) {
  const { pathname } = useLocation()
  const [progress, setProgress] = useState('idle')

  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    })
  }, [pathname])

  useEffect(() => {
    if (prefersReducedMotion()) return undefined
    setProgress('start')
    const mid = window.setTimeout(() => setProgress('done'), 180)
    const end = window.setTimeout(() => setProgress('idle'), 520)
    return () => {
      window.clearTimeout(mid)
      window.clearTimeout(end)
    }
  }, [pathname])

  return (
    <>
      <div
        className={`route-progress route-progress--${progress}`}
        aria-hidden
      />
      <div key={pathname} className="page-motion">
        {children}
      </div>
    </>
  )
}
